module.exports = __webpack_public_path__ + "img/yd3@2x.05b9716d.png";